"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickSearch = void 0;
const react_1 = __importDefault(require("react"));
const QuickSearch = ({ quickSearch }) => {
    if (quickSearch)
        return (react_1.default.createElement("div", { "data-ref": "quick-search" }, quickSearch.links.map((link, index) => (react_1.default.createElement("div", { key: index },
            react_1.default.createElement("a", { href: link.url, target: "_blank", rel: "noreferrer noopener" }, link.display_text))))));
    return null;
};
exports.QuickSearch = QuickSearch;
//# sourceMappingURL=QuickSearch.js.map